/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.auditoriasinventario': 'Auditorías de inventario',
  'auditoriasinventario.NumeroDocumento': 'N° Documento',
  'auditoriasinventario.FechaCreacion': 'Fecha creación',
  'auditoriasinventario.BodegaOrigenDescripcion': 'Bodega origen descripción',
  'auditoriasinventario.BodegaDestinoDescripcion': 'Bodega destino descripción',
  'auditoriasinventario.DocumentoRelacionado': 'Documento relacionado',
  'auditoriasinventario.CodigoDocumentoPadre': 'Documento Padre',
  'auditoriasinventario.EstadoDocumento': 'Estado documento',
  'auditoriasinventario.Bodegas': 'Bodegas',
  'auditoriasinventario.FechaInicial': 'Fecha inicial',
  'auditoriasinventario.datosDocumento': 'Datos documento',
  'auditoriasinventario.detallesDocumento': 'Detalles del documento',
  'auditoriasinventario.bodegaOrigen': 'Bodega origen',
  'auditoriasinventario.etapaDescripcion': 'Etapa',
  'auditoriasinventario.observaciones': 'Observaciones',
  'auditoriasinventario.busquedaDetalles': 'Busqueda detalles',
  'auditoriasinventario.FechaFinal': 'Fecha final',
  'auditoriasinventario.PersonaCreacion': 'Persona asociada',
  'auditoriasinventario.ConteoUnico': 'Conteo único',
  'auditoriasinventario.Detalles.CodigoBarras': 'Código barras',
  'auditoriasinventario.Detalles.DescripcionItem': 'Descripción item',
  'auditoriasinventario.Detalles.CantidadRecibida': 'Cantidad',
  'auditoriasinventario.Detalles.Serial': 'Serial',
  'auditoriasinventario.Detalles.Lote': 'Lote',
  'auditoriasinventario.Detalles.FechaVencimiento': 'Fecha vencimiento',
  'auditoriasinventario.Detalles.crearDetalleDocumento': 'Crear detalle documento',
  'auditoriasinventario.Detalles.editarDetalleDocumento': 'Editar detalle documento',
  'auditoriasinventario.Detalles.Division': 'División',
  'auditoriasinventario.realizarConteo': 'Conteo',
  'auditoriasinventario.conteoParcial': 'Conteo parcial',
  'auditoriasinventario.conteoTotal': 'Conteo total',
  'auditoriasinventario.titulo.primerConteo': '1° Conteo',
  'auditoriasinventario.titulo.segundoConteo': '2° Conteo',
  'auditoriasinventario.alerta.fechasInicialInvalida': 'La fecha inicial debe ser menor a la fecha final',
  'auditoriasinventario.alerta.fechaIncompleta': 'Ingrese las dos fechas para poder realizar la búsqueda',
  'auditoriasinventario.alerta.loteNoIngresado': 'El ítem seleccionado requiere ingresar un lote',
  'auditoriasinventario.alerta.serialNoIngresado': 'El ítem seleccionado requiere ingresar un serial',
  'auditoriasinventario.alerta.fechaVencimientoNoIngresada':
    'El ítem seleccionado requiere ingresar una fecha de vencimiento',
  'auditoriasinventario.alerta.auditoriaCreada':
    'La auditoria aun no se encuentra en conteo, por favor solitite la habilitación para el conteo',
};
